module.exports = "/assets/5d0a2ab386ff5fb17a1e92f957a58178.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PY.png
// module id = 1733
// module chunks = 0